module.exports = __webpack_public_path__ + "images/emoji/chart_with_downwards_trend.07993ff5a27ceea3adf4.png";